<div class="content-section">
    <div class="title-div d-flex justify-content-between align-items-center">              
        <h2 class="background_title">{{ 'INSTITUTION_MANAGEMENT.TRIAL_INSTITUTIONS' | translate }}</h2>
        <button *ngIf="(userData) && (userData.roleName.roleId == 1 || userData.roleName.roleId == 2)" (click)=manageInstitution() class="  btn-continue-bordered-transparent-bd btn-center addInstitution">
            {{ 'INSTITUTION_MANAGEMENT.MANAGE_INSTITUTION_OR_GROUP' | translate }}
        </button>
    </div>
    <div class="container-fluid">
        <div class="row justify-content-end align-items-center mb-3 mr-3">
            <app-bd-search (searchTextChanged)="onSearchTextChanged($event)"></app-bd-search>
        </div>
        <div class="col-12 static-card">
            <bd-light-table 
            [gridData]="gridData || [] | search:searchText:['adminUser','email','institution','countryName','city','groupName','trialStartDate','institutionName','trialEndDate','trialExpiryDue']" 
            [pageInfo]="pageInfo" 
            [fields]="fields" 
            [actionsLast]=true
            [actions]="actionItems"
            ></bd-light-table>
        </div>
        <!-- <lib-ph-bhp-grid [gridData]="gridData | search:searchText:['adminUser','email','institution','countryName','city','groupName','trialStartDate','institutionName','trialEndDate','trialExpiryDue']" 
        [pageInfo]="pageInfo" [fields]="fields" [horizontalAction]="horizontalAction" [actionItems]="actionItems"></lib-ph-bhp-grid> -->
    </div>
    <!-- <div class="container-fluid mt-4 align-items-center">
        <img class="mr-4" src="assets/ph-bhp-institution/svg/Clean Hands.svg">
        <span class="legendText">{{ 'INSTITUTION_MANAGEMENT.CLEAN_HANDS_CAMPAIGN' | translate }}</span>
    </div> -->
</div>

<ng-template #delmodal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"><img
                src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body">
        <p> {{ 'ERROR_MESSAGES.CONFIRMATION.DELETE.RECORD' | translate }} </p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
            <button (click)="delete();modalRef.hide()" class="btn-bd-empty">{{ 'USER_MANAGEMENT.DELETE' | translate }}</button>
        </div>
    </div>
</ng-template>

<ng-template #convertmodal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"><img
                src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body">
        <p> {{ 'ERROR_MESSAGES.CONFIRMATION.CONVERT.ASK' | translate }} </p>
        <p> {{ 'ERROR_MESSAGES.CONFIRMATION.CONVERT.WARNING' | translate }} </p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
            <button (click)="convertToReal();modalRef.hide()" class="btn-bd-empty">{{ 'AUTHORIZATION.CONFIRMATION' | translate }}</button>
        </div>
    </div>
</ng-template>

<ng-template #successconvertmodal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="manageInstitution();modalRef.hide()"><img
                src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body">
        <p> {{ 'ERROR_MESSAGES.CONFIRMATION.CONVERT.RESULT.SUCCESS' | translate }} </p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
            <button (click)="manageInstitution();modalRef.hide()" class="btn btn-continue-bordered-bd">{{ 'CONFIGURE.FILTERS.REFRESH' | translate }}</button>
        </div>
    </div>
</ng-template>

<div class="side-appbar">
    <div class="container-fluid"></div>
</div>

<div id="page_overlay"></div>